export function isBetClosed(value: unknown): boolean {
  return value === true;
}

export function isRaceBettingDisabled(race?: any): boolean {
  return isBetClosed(race?.bet_closed);
}

export function isMarketBettingDisabled(market?: any, race?: any): boolean {
  return isRaceBettingDisabled(race) || isBetClosed(market?.bet_closed);
}

export function isSelectionBettingDisabled(selection?: any, market?: any, race?: any): boolean {
  return isMarketBettingDisabled(market, race) || isBetClosed(selection?.bet_closed);
}

export function resolveRaceById(raceId: number, currentRace: any, nextupData: any): any {
  if (currentRace?.race_id === raceId) return currentRace;

  if (Array.isArray(nextupData)) {
    return nextupData.find((race) => race.race_id === raceId) ?? null;
  }

  return null;
}

export function findMarketById(race: any, marketId: string): any {
  if (!race?.market_groups?.length || !marketId) return null;

  for (const group of race.market_groups) {
    for (const market of group.markets ?? []) {
      if (`${market.name}` === marketId) return market;
    }
  }

  return null;
}

export function isBetClosedOnBetslip(bet: any, currentRace: any, nextupData: any): boolean {
  if (bet.betClosed) return true;

  const race = resolveRaceById(bet.raceId, currentRace, nextupData);
  if (isRaceBettingDisabled(race)) return true;

  if (!bet.isSelectionBet) return false;

  const market = findMarketById(race, bet.marketType);
  if (isMarketBettingDisabled(market, race)) return true;

  const selection = market?.selections?.find((item: any) => item.id === bet.selectionId);
  return isSelectionBettingDisabled(selection, market, race);
}
